// Typed SDK for the oauth-proxy Worker (packages/oauth-proxy). Two routes, both currently only
// used by GoogleDriveProvider.ts's PKCE flow — OneDriveProvider.ts uses MSAL directly against
// Microsoft Graph and never calls this service.
import { apiRequest } from './client.js';

export const oauthProxyApi = {
  exchangeCode(
    code: string,
    codeVerifier: string,
    redirectUri: string,
  ): Promise<{
    access_token: string;
    error?: string;
    expires_in?: number;
    refresh_token?: string;
  }> {
    return apiRequest('oauthProxy', 'POST', '/token', {
      body: { code, code_verifier: codeVerifier, redirect_uri: redirectUri },
    });
  },
  refresh(refreshToken: string): Promise<{ access_token: string; expires_in?: number }> {
    return apiRequest('oauthProxy', 'POST', '/refresh', { body: { refresh_token: refreshToken } });
  },
};
